export class CodeName {
    code: string = '';
    name: string = '';
}

export function compareByName(o1: CodeName, o2: CodeName) {
    if (o1.name < o2.name) {
        return -1;
    }

    if (o1.name > o2.name) {
        return 1;
    }
    return 0;
}